<template>
  <div class="hab-list-empty">
    <template v-if="isErrorServer">
      <div class="hab-list-empty__title">{{ $t('common.something_went_wrong') }}</div>
      <div>
        <img src="/public/images/route-no-schedule.png">
      </div>
    </template>
    <template v-else>
      <div class="hab-list-empty__title">{{ $t('common.result_empty_title') }}</div>
      <div>
          <div>{{ $t('common.result_empty_content_1') }}</div>
          <div><strong>{{ emptyContent }}</strong></div>
          <div class="hab-list-empty__note">{{ $t('common.result_empty_content_3') }}</div>
        <div>
          <img src="/public/images/route-no-schedule.png">
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    emptyContent: {
      type: String,
      default: "",
    },
    isErrorServer: {
      type: Boolean,
      default: false
    }
  }
}
</script>
